import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Pagination extends Component {
  static propTypes = {
    generateSearchURL: PropTypes.func.isRequired,
    gotoPage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    pageResultCount: PropTypes.number.isRequired,
    totalResultCount: PropTypes.number.isRequired,
  }

  gotoPageFactory = (page) => (e) => {
    e.preventDefault()
    this.props.gotoPage(page)
  }

  render () {
    const {
      generateSearchURL,
      page: currentPage,
      pages,
      pageResultCount,
      totalResultCount,
    } = this.props

    if (totalResultCount === 0) {
      return null
    }

    let firstResult = ((currentPage - 1) * pageResultCount) + 1
    let lastResult = firstResult + pageResultCount - 1

    if (currentPage === pages) {
      firstResult = totalResultCount - pageResultCount + 1
      lastResult = totalResultCount
    }

    return (
      <div className='wrapper text-center pagination'>
        <div className='btn-group btn-group--pagination'>
          {(currentPage > 2) && (
            <a
              className='btn btn--large btn--grey-light btn--outline'
              href={generateSearchURL('', { page: 1 })}
              onClick={this.gotoPageFactory(1)}
            >
              <i className='fa fa-angle-double-left' />
            </a>
          )}
          {(currentPage > 1) && (
            <a
              className='btn btn--large btn--grey-light btn--outline'
              href={generateSearchURL('', { page: currentPage - 1 })}
              onClick={this.gotoPageFactory(currentPage - 1)}
            >
              {currentPage - 1}
            </a>
          )}
          <a
            className='btn btn--large btn--primary'
            href={generateSearchURL('', { page: currentPage })}
            onClick={this.gotoPageFactory(currentPage)}
          >
            {currentPage}
          </a>
          {(currentPage < pages) && (
            <a
              className='btn btn--large btn--grey-light btn--outline'
              href={generateSearchURL('', { page: currentPage + 1 })}
              onClick={this.gotoPageFactory(currentPage + 1)}
            >
              {currentPage + 1}
            </a>
          )}
          {(currentPage < (pages - 1)) && (
            <a
              className='btn btn--large btn--grey-light btn--outline'
              href={generateSearchURL('', { page: pages })}
              onClick={this.gotoPageFactory(pages)}
            >
              <i className='fa fa-angle-double-right' />
            </a>
          )}
        </div>
        <div className='pagination__text'>
          {firstResult} - {lastResult} of {totalResultCount} properties.
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pagination.js